export function trimURL(url) {
  let index = 0;
  let newURL = url;
  index = url.indexOf('?');
  if (index === -1) {
    index = url.indexOf('#');
  }
  if (index !== -1) {
    newURL = url.substring(0, index);
  }
  return newURL;
}
